import { createSlice } from "@reduxjs/toolkit";
import { toggleArrayValue } from "./reduxUtils";

const initialState = {
  checkedIds: [],
};
const checkboxSlice = createSlice({
  name: "checkbox",
  initialState,
  reducers: {
    toggleCheckbox: (state, action) => {
      state.checkedIds = toggleArrayValue(state.checkedIds, action.payload);
    },
    clearCheckedIds: (state) => {
      state.checkedIds = [];
    },
  },
});

export const { toggleCheckbox, clearCheckedIds } = checkboxSlice.actions;
export default checkboxSlice.reducer;
